import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  backdrop-filter: blur(10px);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  width: 90%;
  max-width: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  overflow: hidden;
  max-height: 90vh;
  overflow-y: auto;

  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transform: ${({ $isAnimating }) =>
    $isAnimating
      ? "translate(-50%, -50%) scale(1) translateY(0)"
      : "translate(-50%, -50%) scale(0.8) translateY(50px)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  border-radius: 24px;
  border: 1px solid #18181b;
  background: #0c0c0e;
`;

export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const Row = styled.div`
  display: flex;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalText = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  cursor: ${(props) => (props.$click ? "pointer" : "default")};
  line-height: 20px; /* 142.857% */

  &:hover {
    text-decoration: ${(props) => (props.$click ? "underline" : "none")};
  }
`;

export const DiscountBadge = styled.div`
  background: linear-gradient(135deg, #43e97b, #38f9d7);
  color: #1a1a2e;
  padding: 12px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
`;

export const TutorialButton = styled.button`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"};
  border: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.2)"};
  color: #2877D9;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.15)"};
    transform: translateY(-1px);
  }
`;

export const InputLabel = styled.label`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const ModelNameInput = styled.input`
  border-radius: 12px;
  border: 0.5px solid #3d3d45;
  background: #18181b;

  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    border-color: #2877D9;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

export const BackButton = styled.button`
  flex: 1;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"};
  border: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.2)"};
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.15)"};
  }
`;

export const ContinueButton = styled.button`
  display: flex;
  width: 100%;
  max-width: 180px;
  height: 42px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  margin: 0 auto;
  outline: none;

  color: #09090b;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
